import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25f3dfee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LoadingWrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"Loading\" data-v-25f3dfee><div class=\"Dot\" data-v-25f3dfee></div><div class=\"Dot\" data-v-25f3dfee></div><div class=\"Dot\" data-v-25f3dfee></div></div><div class=\"Text\" data-v-25f3dfee>Loading..</div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}